const FORM_ID = process.env.REACT_APP_SUBMIT_FORM_ID;

export const submitForm = async (query) => {
  const url = `https://docs.google.com/forms/d/e/${FORM_ID}/formResponse?${new URLSearchParams(query)}&submit=SUBMIT`;

  try {
    await fetch(url, {
      method: 'POST',
      mode: 'no-cors', // Google only supports 'no-cors' for form submissions
      redirect: 'follow',
      referrer: 'no-referrer',
    });
    // Fetch does not return a response body in 'no-cors' mode, so we cannot check the response status.
    // However, if it reaches this point, we assume the submission was successful.
  } catch (error) {
    // Handle any errors that occur during the fetch operation
    throw new Error('Failed to submit form: ' + error.message);
  }
};
